import { replace } from 'react-router-redux';
import { clearSubmitErrors } from 'redux-form';

import { loading, success, error } from 'State/actions';
import { resetDirty } from 'State/dirtyTracking/actions';
import { SchoolCalendarFieldEnum as Fields } from 'Common/FieldEnum';
import * as types from './types';
import { validate } from 'Common/ReduxFormSubmitValidation';
import { SCHOOL_CALENDAR_FORM_NAME } from 'Common/FormEnum';

export const fetchCalendar = id => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.SCHOOL_CALENDAR_FETCHING, true));

    try {
      const response = await MPWWebApi.getGeneric(`SchoolCalendar/${id}`);
      dispatch(
        success(types.SCHOOL_CALENDAR_FETCH, {
          calendar: response.data.Data,
          isNew: id === '0',
        })
      );
    } catch (ex) {
      dispatch(error(types.SCHOOL_CALENDAR_FETCH_ERROR, ex));
    }

    dispatch(loading(types.SCHOOL_CALENDAR_FETCHING, false));
  };
};

export const saveCalendar = (model, resetScroll) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.SCHOOL_CALENDAR_SUBMITTING, true));

    const { calendar } = getState().SchoolCalendarState;
    const exceptions = calendar.data[Fields.SchoolCalendarExceptions];
    const assignments = calendar.data[Fields.SchoolCalendarSiteMasters].filter(
      scsm => scsm[Fields.Assigned]
    );

    model = {
      ...model,
      [Fields.GracePeriodCalendarDays]:
        model[Fields.GracePeriodCalendarDays] || 0,
      [Fields.CepTransferOperationalDays]:
        model[Fields.CepTransferOperationalDays] || 0,
      [Fields.MbeOperationalDays]: model[Fields.MbeOperationalDays] || 0,
      [Fields.SchoolCalendarExceptions]: exceptions,
      [Fields.SchoolCalendarSiteMasters]: assignments,
    };

    await validate(
      dispatch,
      MPWWebApi,
      'SchoolCalendar/Validate',
      model,
      types.SCHOOL_CALENDAR_SUBMITTING,
      resetScroll
    );

    try {
      await MPWWebApi.postGenericInsertUpdate('SchoolCalendar/Write', model);

      dispatch(resetDirty());
      dispatch(success(types.SCHOOL_CALENDAR_SUBMIT));
      dispatch(replace('/schoolcalendar'));
    } catch (ex) {
      dispatch(error(types.SCHOOL_CALENDAR_SUBMIT_ERROR, ex));
    }

    dispatch(loading(types.SCHOOL_CALENDAR_SUBMITTING, false));
  };
};

export const deleteCalendar = calendarId => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.SCHOOL_CALENDAR_DELETING, true));

    try {
      await MPWWebApi.postGenericDelete('SchoolCalendar', calendarId);
      dispatch(success(types.SCHOOL_CALENDAR_DELETE));
    } catch (ex) {
      dispatch(error(types.SCHOOL_CALENDAR_DELETE_ERROR, ex));
    }

    dispatch(loading(types.SCHOOL_CALENDAR_DELETING, false));
  };
};

export const clearSchoolCalendarErrorSuccess = () => {
  return {
    type: types.SCHOOL_CALENDAR_CLEAR_ERROR_SUCCESS,
  };
};

export const addException = exception => {
  return {
    type: types.SCHOOL_CALENDAR_ADD_EXCEPTION,
    payload: exception,
  };
};

export const editException = (exception, index) => {
  return {
    type: types.SCHOOL_CALENDAR_EDIT_EXCEPTION,
    payload: { exception, index },
  };
};

export const removeException = index => {
  return dispatch => {
    dispatch({
      type: types.SCHOOL_CALENDAR_REMOVE_EXCEPTION,
      payload: index,
    });
    dispatch(clearSubmitErrors(SCHOOL_CALENDAR_FORM_NAME));
  };
};

export const toggleAssignment = indexes => {
  return {
    type: types.SCHOOL_CALENDAR_TOGGLE_ASSIGNMENT,
    payload: indexes,
  };
};

export const toggleCheckAllAssignments = displayedSites => {
  return {
    type: types.SCHOOL_CALENDAR_TOGGLE_ALL_ASSIGNMENTS,
    payload: displayedSites,
  };
};

/**
 * @deprecated Moved to modal for creating and editing exceptions so can no longer
 *             have submit validation for individual exceptions
 */
// async function validate(dispatch, MPWWebApi, resourceName, model, loadingType) {
//   await MPWWebApi.postGenericInsertUpdate(resourceName, model).catch(error => {
//     dispatch(loading(loadingType, false));

//     if (has(error, 'response.data.Errors')) {
//       throw new SubmissionError(
//         error.response.data.Errors.reduce((acc, cur) => {
//           //SchoolCalendarExceptions[0].BeginDay
//           const [rootPart, property] = cur.Title.split('.');

//           if (property) {
//             const [root, indexPart] = rootPart.split('[');

//             if (!acc.hasOwnProperty(root)) {
//               acc[root] = [];
//             }

//             const index = parseInt(indexPart.replace(']'), 10);

//             if (!acc[root][index]) {
//               acc[root][index] = {};
//             }

//             acc[root][index][property] = cur.Message;
//           } else {
//             acc[cur.Title] = cur.Message;
//           }

//           return acc;
//         }, {})
//       );
//     } else {
//       throw new SubmissionError({
//         _error: 'The information entered is invalid',
//       });
//     }
//   });
// }



// WEBPACK FOOTER //
// ./src/pages/schoolcalendar/state/calendar/actions.js